import Lottie from 'lottie-react';

import emptyDeaCds from '../jsons/empty-dea-cds.json';

const EmptyDeaCds = props => {
  return <Lottie loop={false} animationData={emptyDeaCds} {...props} />;
};

export default EmptyDeaCds;
